<template>
  <div>
    <v-sheet color="blue-grey lighten-1">
      <v-text-field
        name="name"
        label="Search by Person Name"
        v-model="searchText"
        class="pa-2"
        prepend-inner-icon="mdi-magnify"
        rounded
        solo
        hide-details
        dense
      >
      </v-text-field>
    </v-sheet>

    <v-list class="pa-0">
      <v-list-item class="pa-0" v-for="(person, i) in personList" :key="person.id">
        <v-list-item-content :class="[i !== 0 ? 'border-top' : '', 'pa-0']">
          <person-card v-bind="person"></person-card>
        </v-list-item-content>
      </v-list-item>

      <v-list-item class="pa-0" v-if="personList.length === 0">
        <v-list-item-content class="text-center">
          <span>no data</span>
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import Fuse from "fuse.js";
import apiPerson from "@/apis/Person";
import PersonCard from "@/components/Card/Person";

export default {
  name: "PersonList",
  components: { PersonCard },
  data() {
    return {
      searchText: "",
      dataList: [],
      loading: true
    };
  },
  computed: {
    personList() {
      if (this.searchText === "") return this.dataList;
      return this.searchList;
    },
    searchList() {
      const options = {
        keys: ["name_en", "name_zh", "service_organization", "service_title"]
      };

      const fuse = new Fuse(this.dataList, options);

      const result = fuse.search(this.searchText);
      return result.map(({ item }) => item);
    }
  },
  methods: {
    async fetchData() {
      let result = null;

      if (this.$route.name === "PersonListByPosition") {
        const position = this.$route.params.position;
        result = await apiPerson.getByPosition(position);
      } else {
        result = await apiPerson.get();
      }

      this.dataList = result;
      this.loading = false;
    }
  },
  async mounted() {
    await this.fetchData();
  }
};
</script>
